export enum TextLengthEnum {
  Short = 1,
  Medium = 2,
  Long = 3
}

export enum TextStyleEnum {
  Friendly = 1,
  Formal = 2,
  Simple = 3
}

export enum TextGoalEnum {
  Promotional = 1,
  Informative = 2,
  CallToAction = 3
}

